import { Pagination } from "@cpj-ai/panel-npm-package";
import { GetEmployeesQuery } from "@graphql/generated";
import PostHiringEmployeeCard from "./PostHiringEmployeeCard";

interface IPostHiringEmployeeListProps {
  employeesList?: GetEmployeesQuery;
  totalCount?: number | null;
  currentPage: number;
  pageSize: number;
  isLoading: boolean;
  onPageChange: (newPage: number) => void;
  onPageSizeChange?: (newPageSize: number) => void;
}

const PostHiringEmployeeList = ({
  employeesList,
  totalCount,
  currentPage,
  pageSize,
  isLoading,
  onPageChange,
  onPageSizeChange,
}: IPostHiringEmployeeListProps) => {
  return (
    <div className="flex flex-col gap-4">
      {employeesList?.organization?.employee?.list?.edges.map((employee) => (
        <PostHiringEmployeeCard key={employee?.node?.id} employee={employee} layout={"LIST"} />
      ))}
      {!isLoading && (employeesList?.organization?.employee?.list?.edges?.length ?? 0) > 0 && (
        <div className="flex justify-center mt-4">
          <Pagination
            total={totalCount ?? 0}
            page={currentPage}
            pageSize={pageSize}
            onChange={onPageChange}
            onPageSizeChange={onPageSizeChange}
          />
        </div>
      )}
    </div>
  );
};

export default PostHiringEmployeeList;
